export default __webpack_public_path__ + "static/media/threeDots.69d09fe5.svg";